import { Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DownloadIcon from "@mui/icons-material/Download";

export default function DownloadMaskButton() {

  const dispatch = useDispatch();

  const mask = useSelector((state) => state.imageEditor.mask);

  const handleMaskDownload = (event) => {
    // const mask = exportMask();
    if (!mask) return;
    const link = document.createElement("a");
    link.href = mask;
    link.download = "mask.png";
    link.click();
  };

  return (
    <Button variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleMaskDownload}
      disabled={!mask}
    >
      Download Mask
    </Button>
  );
}
